const version = '1.3.5' ;

export default version ;